import { Star } from "lucide-react";

interface TestimonialCardProps {
  name: string;
  rating: number;
  testimonial: string;
  imageUrl: string;
}

export function TestimonialCard({
  name,
  rating,
  testimonial,
  imageUrl
}: TestimonialCardProps) {
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star 
          key={i} 
          className={`w-4 h-4 ${i < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} 
        />
      );
    }
    return stars;
  };

  return (
    <div className="bg-card rounded-lg shadow-sm p-5 hover:shadow-md transition-shadow">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 rounded-full overflow-hidden mr-3">
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h4 className="font-medium text-card-foreground">{name}</h4>
          <div className="flex">
            {renderStars(rating)}
          </div>
        </div>
      </div>
      <p className="text-muted-foreground text-sm italic">
        "{testimonial}"
      </p>
    </div>
  );
}